import dayjs from "dayjs";

export const monthNameDateFormat = (date) => !!date ? dayjs(date).format("MMMM D, YYYY") : "";

export const dateTimeFormat = (date) => !!date ? 
  dayjs(date).format("YYYY-MM-DD HH:mm:ss") : undefined;

export function getMonthName(birthMonthNum) {
  return [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ][birthMonthNum - 1];
}

export function parseDate(dateTimeStr) {
  // Parse Format 2011-06-21T00:00:00 to {month, day, year}
  const parseDateRE = /^(\d{4})-(\d{2})-(\d{2})/;
  const noLeadingZeroRE = /^0?(\d+)$/;
  const result = parseDateRE.exec(dateTimeStr);

  const [fullDate = "", year = "", monthLeadingZero = "", dayLeadingZero = ""] =
    result || [];

  const dayResult = noLeadingZeroRE.exec(dayLeadingZero);
  const monthResult = noLeadingZeroRE.exec(monthLeadingZero);

  const [, day = ""] = dayResult || [];
  const [, month = ""] = monthResult || [];

  return { fullDate, year, month, day, monthLeadingZero, dayLeadingZero };
}

export const yearOnlyFormatTest = (dateString) => {
  const yearOnlyRE = /^\d{4}$/
  if (yearOnlyRE.test(dateString)) { // just year
    return `${dateString}-12-31`;
  }

  return dateString
}
